/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_LeftInputs */

const en_ocr_crop_left = /** @type {(inputs: Ocr_Crop_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left (%)`)
};

const fr_ocr_crop_left = /** @type {(inputs: Ocr_Crop_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gauche (%)`)
};

const de_ocr_crop_left = /** @type {(inputs: Ocr_Crop_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links (%)`)
};

const it_ocr_crop_left = /** @type {(inputs: Ocr_Crop_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinistra (%)`)
};

const ru_ocr_crop_left = /** @type {(inputs: Ocr_Crop_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Левый (%)`)
};

const es_ocr_crop_left = /** @type {(inputs: Ocr_Crop_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izquierda (%)`)
};

const zh_cn2_ocr_crop_left = /** @type {(inputs: Ocr_Crop_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左边 （％）`)
};

const ja_ocr_crop_left = /** @type {(inputs: Ocr_Crop_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左 （％）`)
};

const hi_ocr_crop_left = /** @type {(inputs: Ocr_Crop_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाएं (%)`)
};

const pt_pt2_ocr_crop_left = /** @type {(inputs: Ocr_Crop_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquerda (%)`)
};

/**
* | output |
* | --- |
* | "Left (%)" |
*
* @param {Ocr_Crop_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_left = /** @type {((inputs?: Ocr_Crop_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_crop_left(inputs)
	if (locale === "de") return de_ocr_crop_left(inputs)
	if (locale === "it") return it_ocr_crop_left(inputs)
	if (locale === "ru") return ru_ocr_crop_left(inputs)
	if (locale === "es") return es_ocr_crop_left(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_crop_left(inputs)
	if (locale === "ja") return ja_ocr_crop_left(inputs)
	if (locale === "hi") return hi_ocr_crop_left(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_crop_left(inputs)
	return en_ocr_crop_left(inputs)
});